module.exports = __webpack_public_path__ + "static/app-flow1-2a2fcbb6d2a38347bd486bf76cd3138a.png";